<script>
import { PaymentMethodService } from '@/services'

export default {
  props: {
    branchId: {
      type: Number,
      default: undefined
    }
  },

  data() {
    return {
      items: [],
      isLoaded: false
    }
  },

  watch: {
    branchId() {
      this.fetch()
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      try {
        const {
          data: { result }
        } = await PaymentMethodService.getAll({
          branch: this.branchId,
          all: true
        })

        this.items = result.map(item => ({
          id: item.id,
          name:
            item.id === 1
              ? 'เงินสด'
              : this.getName(
                  item.description,
                  item.account_name,
                  item.bank ? item.bank.name : '',
                  item.bank_account_id
                )
        }))
      } catch (e) {
        this.items = []
      } finally {
        this.isLoaded = true
      }
    },

    getName(description, name, bankName, id) {
      return `${description} (${name} (${bankName} ${id}))`.trim()
    }
  },

  render() {
    return (
      this.isLoaded &&
      this.$scopedSlots.default({
        items: this.items
      })
    )
  }
}
</script>
